<template>
    <main class="mt-0" >

        <h3 class="fw-bold d-lg-none p-1"></h3>
        <div class="p-3 p-md-3 p-lg-5 min-vh-100">
            <div class="mb-2 mb-lg-4">
                <div class="d-lg-flex  justify-content-between mb-3">
                    <h5>ANDAMENTO DA OBRA</h5>

                    <div v-if="authenticated" >
                        <button class="btn btn-primary me-2 mb-1"  data-bs-toggle="modal" data-bs-target="#addData"><img src="@/assets/img/calendario.png" width="24"> Cadastrar nova data</button>
                        <button class="btn btn-danger mb-1" data-bs-toggle="modal" data-bs-target="#exportPdfSelect"><img src="@/assets/img/pdf.png" alt="Export PDF" width="24"> Exportar para PDF</button>
                        
                    </div>
                    
                </div>
                
                <!-- <h5 class="text-white rounded-3 p-2 px-3 p-md-4 px-md-5" :style="{backgroundColor: datas.enterprise.cores[0]}">Percentuais executados até <b>{{ ($route.params.data.split('-'))[2] }}/{{ (new Date(($route.params.data.split('-'))[0], ($route.params.data.split('-'))[1] - 1, ($route.params.data.split('-'))[2])).toLocaleString('default', { month: 'long' }).toUpperCase().substring(0, 3) }}/{{ ($route.params.data.split('-'))[0]}}</b></h5> -->
                 <h5 class="text-white rounded-3 p-2 px-3 p-md-4 px-md-5" :style="{backgroundColor: '#222428'}">Percentuais executados até <b>{{ ($route.params.data.split('-'))[2] }}/{{ (new Date(($route.params.data.split('-'))[0], ($route.params.data.split('-'))[1] - 1, ($route.params.data.split('-'))[2])).toLocaleString('default', { month: 'long' }).toUpperCase().substring(0, 3) }}/{{ ($route.params.data.split('-'))[0]}}</b></h5>
            </div>
            
            <div class="row mb-5">
                
                <div class="col-12 d-flex justify-content-center d-xl-block col-xl-7 position-relative img-banner">
                    <div class="card-image" :style="{ backgroundImage: 'url('+banner()+')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}">
                        
                        <span @click="tiggerArquivo()" class="edit-photos btn bg-white"  v-if="authenticated"><img src="@/assets/img/botao-editar.png" width="32"> Alterar Imagem</span>
                        <form action="/" id="photos_construction" style="display:none;" method="POST" enctype="multipart/form-data" v-if="authenticated">
                            <input name="photos_construction" type="file" id="photosConstruction" @change="updateImgConstruction($event)"  accept="image/*">
                        </form> 
                    </div>
                    
                </div>
                <div class="col-xl-5 mt-4 mt-xxl-0">
                    <div class="row div-etapas">
                        <div class="row m-0 p-0 d-lg-none mb-5">
                            <div class="col-6 d-flex align-items-center">
                                <span class="previsto legenda" :style="{backgroundColor: datas.enterprise.cores[1]}"></span>
                                <small class="mx-2 fw-bold fs-6">Previsto</small>
                            </div>
                            <div class="col-6 d-flex align-items-center">
                                <span class="realizado legenda" :style="{backgroundColor: datas.enterprise.cores[0]}"></span>
                                <small class="mx-2 fw-bold fs-6">Realizado</small>
                            </div> 
                        </div>
                        <div class="col-md-6 mb-3 etapa-card"  v-for="(phase, index) in construction.phases" :key="index">
                            <h6 class="fw-bold d-flex justify-content-between"><span>{{ phase.etapa }}</span> <img v-if="authenticated" src="@/assets/img/remover.png" class="etapa-remove" width="24" @click="removeEtapa(index)"></h6>
                            <div class="d-flex flex-column etapas" >
                                <div class="d-flex align-items-center">
                                    <input type="number" class="bg-d mb-0" @keyup="keyUpCamp(phase.previsto, $event)" :style="authenticated ? '' : 'border:none;' " v-model="phase.previsto" :disabled="authenticated ? false : true">
                                    <span class="me-1 mb-0 fw-bold">%</span>
                                    <span style="width:80% !important; background-color:white; height:20px;">
                                        <span class="previsto text-white" :style="{backgroundColor: datas.enterprise.cores[1], display: 'inline-block', height:'20px', width: phase.previsto >= 0 && phase.previsto <= 100  ? phase.previsto + '%' : '0%' }"></span>     
                                    </span>
                                   
                                </div>
                                <div class="d-flex align-items-center">
                                    <input type="number" class="bg-d mb-0" @keyup="keyUpCamp(phase.realizado, $event)" :style="authenticated ? '' : 'border:none;' " v-model="phase.realizado" :disabled="authenticated ? false : true">
                                    <span class="me-1 mb-0 fw-bold">%</span>
                                    <span style="width:80% !important; background-color:white; height:20px;">
                                        <span class="realizado text-white" :style="{ backgroundColor: datas.enterprise.cores[0], display: 'inline-block', height:'20px', width: phase.realizado >= 0 && phase.realizado <= 100  ? phase.realizado + '%' : '0%' }"></span>
                                    </span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <span class="div-etapas-span mb-lg-5 d-flex justify-content-center"><span class="scroll-down"></span></span>
                     <div class="row m-0 p-0 d-none d-lg-flex">
                        <div class="col-md-6 d-flex align-items-center">
                            <span class="previsto legenda" :style="{backgroundColor: datas.enterprise.cores[1]}"></span>
                            <small class="mx-2 fw-bold fs-6">Previsto</small>
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                            <span class="realizado legenda" :style="{backgroundColor: datas.enterprise.cores[0]}"></span>
                            <small class="mx-2 fw-bold fs-6">Realizado</small>
                        </div> 

                    </div>
                </div>
            </div>
            <div class="observacoes">
                <h5 class="fw-bold">OBSERVAÇÕES:</h5>
                <p v-if="!authenticated ">{{ construction.observations }}</p>
                <textarea v-else @keyup="updateConstructionNotReload" v-model="construction.observations"></textarea>
            </div>
        </div>
        <div class="modal" tabindex="-1" id="addEtapa"  v-if="authenticated" >
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Nova Etapa</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="construction" class="form-label">Etapa:</label>
                        <input type="text" class="form-control" id="nameEtapa">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" @click="novaEtapa">Finalizar</button>
                </div>
                </div>
            </div>
        </div>  
        <div class="modal" tabindex="-1" id="addData" v-if="authenticated">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Nova Atualização de Obra</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="construction" class="form-label">Data:</label>
                        <input type="date" :value="setInputDate()" class="form-control" id="novaObraData">
                    </div>
                    <small class="text-warning" id="retornoNovaObra"></small>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-primary" @click="novaObra">Finalizar</button>
                </div>
                </div>
            </div>
        </div> 
        
        <div class="modal" tabindex="-1" id="exportPdfSelect"  v-if="authenticated" >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione o idioma</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex">
                            <button class="btn btn-primary" @click="exportPdf('pt')">PT</button>
                            <button class="btn btn-danger mx-2" @click="exportPdf('en')">EN</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </main>
</template>
<script>
import Cookies from "js-cookie";
import { mapGetters, mapActions } from "vuex";
export default {
    name: 'DataFilter',
    data() {
        return {
            construction:{
                photos_construction:["default-img-obra.png"]
            },
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                if (this.$route.params && this.$route.params.data) {

                    var data = this.$route.params.data.split('-');
                    document.title = `Andamento da Obra - ${data[2]}/${data[1]}/${data[0]}`;
                    this.setDate(this.$route.params.data);
                }
            }
        }
    },
    computed: {
        ...mapGetters(["datas", "dataTitles", "authenticated"])
    },
    methods:{
        ...mapActions(["fetchData"]),
        setInputDate(){
            var hoy = new Date();
            var d = hoy.getDate();
            var m = hoy.getMonth()+1;
            var y = hoy.getFullYear();

            if(d < 10)
                d = "0"+d;

            if(m < 10)
                m = "0"+m;

            var data = y+"-"+m+"-"+d;
            return data;
        },
        async setDate(data){
            
            await fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA.replace('{id}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{date}', data)}`)
            .then((response) => response.json())
            .then((data) => {
                if(data.enterprise == 'not found' || data.enterprise==null){
                    this.$router.push('/');
                }else{
                    this.construction = data.enterprise;
                }
            })
            .catch((err) => console.error(err));
            
        },
        novaEtapa(){
            const etapa = document.getElementById('nameEtapa');
            
            if(etapa.value != '' && this.authenticated){
               const newEtapa = { etapa: etapa.value, previsto: '0.0', realizado: '0.0', ocultar: "0" }
               this.construction.phases.push(newEtapa);
               this.updateConstruction();
               this.closeModal('addEtapa');
            }
        },
        removeEtapa(index){
            
            if(this.authenticated){
                if(confirm(`Você está tem certeza que deseja remover a etapa: '${this.construction.phases[index].etapa}'?`)){
                    this.construction.phases.splice(index, 1);
                    this.updateConstruction();
                }
            }
            
        },
        novaObra(){
            const date = document.getElementById('novaObraData').value;

            const verif = this.datas.enterprise.constructionscolumn.findIndex(c => c.date === date);

            if(verif == -1){
                
                var token = Cookies.get('_mysapp_token');

                fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_CREATE.replace('{id}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{date}', date)}`, {
                method:'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                }
                })
                .then((response) => response.json())
                .then((data) => {
                    if(data.created == 'ok'){
                        this.closeModal('addData');
                        this.fetchData();
                        this.$router.push(`/${date}`);
                    }else{
                    alert('Não foi possível adicionar uma nova data. Tente novamente mais tarde.');
                    document.location.reload();
                    }
                })
                .catch((err) => console.error(err));

            }else{
                const retorno = document.getElementById('retornoNovaObra');
                retorno.innerText = 'Esta data já foi cadastrada!';
                setTimeout(() => {
                retorno.innerText = '';
                }, 2500)
            }
        },
        keyUpCamp(p, event){
            if(event.target.value < 0 || event.target.value  > 100){
                p = 0;
                event.target.value = 0;
            }else{
                this.updateConstructionNotReload();
            }
            
        },
       
        closeModal(modl){
            const modal = document.getElementById(modl);
            modal.classList.remove('show');
            modal.style.display = 'none';
            document.querySelector('.modal-backdrop').remove();

            const body = document.querySelector('body');
            body.classList.remove('modal-open');
            body.style.overflow="auto";
        },
        banner(){
            return `${process.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${this.construction.photos_construction[0]}`;
        },
       
        tiggerArquivo(){
            const input = document.getElementById('photosConstruction');
            input.click();
        },
        exportPdf(lang){
            var token = Cookies.get('_mysapp_token');
            fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_APIEXPORT.replace('{id_enterprise}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{id}', this.construction.id)}?lang=${lang}`, {
                method:'GET',
                headers:{
                    'Authorization' : 'Bearer ' + token
                }
            }).then((res) => { return res.blob(); })
                .then((data) => {
                    var a = document.createElement("a");
                    a.href = window.URL.createObjectURL(data);
                    a.download = `${this.datas.enterprise.name} - Andamento da Obra - ${this.construction.date}`;
                    a.click();
                });
        },
        updateImgConstruction(e){

            const formData = new FormData(e.target.parentNode);

            var token = Cookies.get('_mysapp_token');
            
            fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace('{id_enterprise}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{id}', this.construction.id)}`, {
            method:'POST',
            headers:{
                'Authorization' : 'Bearer ' + token
            },
            body:formData   
            })
            .then((response) => response.json())
            .then((data) => {
                e.target.value = null;
                if(data.update == 'ok'){
                    this.construction.photos_construction = data.construction.photos_construction;
                }else{
                    alert('Não foi possível atualizar os dados. Tente novamente mais tarde.');
                    document.location.reload();
                    
                }
                
            }).catch((err) => console.error(err));
        },
        setPorcetagem(padrao, porcentagem){
            return padrao * (porcentagem / 100);
        },
        updateConstruction(){
            if(this.authenticated){
                var token = Cookies.get('_mysapp_token');
                fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace('{id_enterprise}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{id}', this.construction.id)}`, {
                method:'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                },
                body:JSON.stringify(this.construction)   
                })
                .then((response) => response.json())
                .then((data) => {

                    if(data.update == 'ok'){
                        this.construction = data.construction;
                    }else{
                        alert('Não foi possível atualizar os dados. Tente novamente mais tarde.');
                        document.location.reload();
                    }
                    
                })
                .catch((err) => console.error(err));
            }
        },
        updateConstructionNotReload(){
            if(this.authenticated){
                var token = Cookies.get('_mysapp_token');
                fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace('{id_enterprise}', process.env.VUE_APP_ENV_EMPREENDIMENTOID).replace('{id}', this.construction.id)}`, {
                method:'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization' : 'Bearer ' + token
                },
                body:JSON.stringify(this.construction)   
                })
                .then((response) => response.json())
                .then((data) => {

                    if(data.update != 'ok'){
                        alert('Não foi possível atualizar os dados. Tente novamente mais tarde.');
                        document.location.reload();
                    }
                    
                })
                .catch((err) => console.error(err));
            }
        }
    },

}
</script>
<style scoped>
    .etapas input{
        width: 40px;
        height: 20px;
        border: 1px solid #e7e7e7;
        text-align: center;
    }
    .observacoes textarea{
        border: 1px solid #e6e6e6;
        color: rgb(41 44 51);
        width: 100%;
        height: 150px;
    }
    input[type=number]::-webkit-inner-spin-button { 
        -webkit-appearance: none;
        
    }
    input[type=number] { 
        -moz-appearance: textfield;
        appearance: textfield;
    }
    .legenda{
        width: 25px;
        height: 25px;
        display: inline-block;
    }
    /* .etapa-card:hover .etapa-remove {
        display: block !important;
    } */
    .etapa-remove {
        cursor: pointer;
        display: none;
    }
    .edit-photos{
        position: absolute;
        top: 10px;
        left: 10px;
        display: none;
    }
    .img-banner:hover .edit-photos{
        display: block;
    }
    .card-image{
        height:500px;
        width:100%;
    }
    @media(max-width:400px){
        .card-image{
            height:300px;
            width:100%;
        }
    }
    @media(min-width:401px) and (max-width:450px){
        .card-image{
            height:350px;
            width:100%;
        }
    }
    @media(min-width:451px) and (max-width:767px){
        .card-image{
            height:400px;
            width:100%;
        }
    }

</style>